/**
 * ListReportParam
 * @author ftgibran
 */
import {ResponseFill, HttpIgnore, HttpBody, $, classToPlain} from 'simpli-web-sdk'
import DeliveryRequest from '@/model/request/DeliveryRequest'
import {TipoRelatorio} from '@/enums/TipoRelatorio'

@HttpIgnore()
export default class ListReportParam extends DeliveryRequest {
  readonly $name: string = 'ListReportParam'

  @ResponseFill('idTipoRelatorio')
  idTipoRelatorio: TipoRelatorio | null = null

  async generateReport(spinner = 'generateReport') {
    const params: any = classToPlain(this)

    Object.keys(params).forEach((key: string) => {
      params[key] = params[key] || undefined
    })

    const fetch = async () => await new HttpBody(Boolean).POST(`/user/carga/report/generate`, null, {params})
    return await $.await.run(fetch, spinner)
  }
}
